import { createI18n } from 'vue-i18n';


import en from './locales/en.json';
import sr from './locales/sr.json';
import sq from './locales/sq.json';

const i18n = createI18n({
   legacy: false,
   locale: 'sq', 
   fallbackLocale: 'sq',
   messages: {
      en,
      sr,
      sq
   }
});

export default i18n;